import api from "../api/api";

export const getPrinters = async () => (await api.get("/printers")).data;

export const getPrinterDetails = async (id) => (await api.get(`/printers/${id}`)).data;

export const createPrinter = async (data) => (await api.post("/printers", data)).data;

// 🔥 ESSA LINHA É A QUE ESTAVA FALTANDO:
export const updatePrinter = async (id, data) => (await api.put(`/printers/${id}`, data)).data;